// extracted by mini-css-extract-plugin
module.exports = {"styledButton":"ged5EtQg"};